<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid">
            <v-card class="col-md-12" v-if="dialog">
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <a href="#"  class="btn btn-default float-right" style="font-size: 18pt;margin-top: -5%" @click.prevent="close">{{$t('Fermer')}}</a>

                <v-card-text>
                    <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>
                    <v-alert v-if="errors.operation" dense outlined type="error">
                        {{errors.operation}}
                    </v-alert>
                    <v-form id="roles-form" ref="form" v-model="valid" :lazy-validation="lazy"  enctype="multipart/form-data">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field :rules="codeRules" v-model="editedItem._code" label="Code"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" >
                                <v-text-field :rules="labelRules" required v-model="editedItem._label" label="Libellé" ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-container fluid >
                            <h6>{{$t('dashboard')}}</h6>
                            <hr>
                            <div class="action-inputs-group">
                                <v-checkbox v-model="permissions" name="actions[]" :value="'browse_dashboard'"  label="Naviguer"></v-checkbox>
                            </div>
                        </v-container>
                        <v-container fluid>
                            <h6> {{$t('administration')}}</h6>
                            <hr>
                            <div class="action-inputs-group">
                                <v-checkbox v-model="permissions" name="actions[]" :value="'browse_administration'"  label="Naviguer"></v-checkbox>
                            </div>
                        </v-container>
                        <v-container fluid  v-for="collection in collections" :key="collection.name">
                              <!--<h6 style="cursor: pointer" @click="checkEntity(collection.name)">
                            </h6>-->
                            <v-checkbox @change="checkEntity(collection.name)">
                                <template v-slot:label>
                                    <span style="color:#29B3A6 ">{{collection.name.capitalize()}}</span>
                                </template>
                            </v-checkbox>

                            <hr>
                            <div class="action-inputs-group">
                                <v-checkbox class="actions-inputs" v-model="permissions" name="actions[]" :value="'browse_'+collection.name"  label="Naviguer"></v-checkbox>
                                <v-checkbox class="actions-inputs" v-model="permissions" name="actions[]" :value="'read_'+collection.name"  label="Lire"></v-checkbox>
                                <v-checkbox class="actions-inputs" v-model="permissions" name="actions[]" :value="'create_'+collection.name"  label="Créer"></v-checkbox>
                                <v-checkbox class="actions-inputs" v-model="permissions" name="actions[]" :value="'update_'+collection.name"  label="Modifier"></v-checkbox>
                                <v-checkbox class="actions-inputs" v-model="permissions" name="actions[]" :value="'delete_'+collection.name"  label="Supprimer"></v-checkbox>
                            </div>
                        </v-container>
                    </v-form>

                    <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>
                    <v-alert v-if="errors.operation" dense outlined type="error">
                        {{errors.operation}}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark"  @click.prevent="close">{{$t('cancel')}}</v-btn>
                    <v-btn color="primary" :disabled="!valid" @click.prevent="save">{{$t('save')}}</v-btn>
                </v-card-actions>
            </v-card>
        <div class="row" v-if="!dialog">
            <div class="col-12 mb-4">
                <v-card>
                    <v-card-title>
                        {{$t('roles.role_management')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="roles"
                            :search="search"
                            sort-by="label"
                            class="elevation-1"
                            :loading="roles===undefined" loading-text="Chargement en cours...">
                        <template v-slot:item._file="{item}">
                            <a :href="item._file">{{getFileOriginalName(item._file)}}</a>
                        </template>
                        <template v-slot:item._created_at="{item}">
                            {{ new Date(item._created_at).toLocaleDateString()}}
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                        <v-btn color="primary" dark class="mb-2" @click.prevent="showForm">{{$t('add')}}</v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }" >
                            <div style="text-align:  right">
                                <v-menu
                                        key="text"
                                        rounded="b-xl">
                                    <template v-slot:activator="{ attrs, on }">

                                            <v-icon

                                            class="black--text "
                                            v-bind="attrs"
                                            v-on="on">mdi-dots-vertical</v-icon>

                                    </template>
                                    <v-list>
                                        <v-list-item
                                                v-for="(action_item, index) in actions_items"
                                                :key="index"
                                                link
                                                @click="editItemAction(item,index)">
                                            <v-list-item-icon>
                                                <v-icon color="#29B3A6">{{action_item.avatar}}</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </template>
                        <template v-slot:no-data>
                            {{$t('no_data')}}
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
        </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from '../../mixins/helpers'


    export default {
        label: "Roles",
        mixins:[helpers(this)],
        data () {
            return {
                formeIsOpen:false,
                submitting:false,
                valid:true,
                lazy:false,
                errors:{},
                search: '',
                dialog: '',
                actions:['browse','create','delete','read','update'],
                id:undefined,
                headers: [
                    {text: 'Code', value: '_code'},
                    {
                        text: 'Libellé',
                        align: 'start',
                        sortable: false,
                        value: '_label',
                    },
                    {text: 'Date', value: '_created_at'},
                    { text: '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _label: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _label: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                permissions:[],
                labelRules: [
                    v => !!v || 'label_required',
                   // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'code_required',
                ],
                fileRules: [
                    v => !!v || 'file_required',
                ],
                actions_items: [
                    { title: "Modifier", avatar: 'mdi-pencil' },
                    { title: "Supprimer", avatar: 'mdi-delete' }
                ],

            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('roles.new_role') : this.$t('roles.update_role')
            },
            ...mapState('roles/',['roles','collections'])
        },
        mounted(){
            this.$store.dispatch('roles/getRoles').then(response=>{
                window.console.log('roles',response)
            });
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            showForm(){
                this.dialog = !this.dialog
            },
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            editItem (item) {
                this.editedIndex = this.roles.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.id = item._id;
                item.permissions.forEach((item)=>{
                    this.permissions.push(item._action+'_'+item._entity)
                });
                this.showForm();

            },
            editItemAction(item,index) {
                switch (index){
                    case 0:
                        this.editItem(item)
                        break;
                    case 1:
                        this.deleteItem(item)
                        break;
                }
            },
            deleteItem (item) {
                const index = this.roles.indexOf(item)
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText:  this.$t('delete'),
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29b3a6"
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('roles/deleteRole', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            save () {
                let VueBox = this;
                    let data = new FormData($('#roles-form')[0]);
                    data.append("code",this.editedItem._code);
                    data.append("label",this.editedItem._label);
                    if (this.id)
                        data.append("id",this.id);
                    this.submitting = true;
                    this.$store.dispatch('roles/setRole',data).then((response)=>{
                        this.submitting = false;
                        if (response.error){
                            this.errors.operation=response.message;
                        }else{
                                VueBox.$parent.resetDatas(VueBox);
                            this.close();
                        }
                    })
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            checkEntity(entity){
                this.actions.forEach((item)=>{
                    let permission = item+'_'+entity;
                    if (this.permissions.includes(permission)){
                        this.permissions = this.permissions.filter(function(item2) {
                            return item2 !== permission
                        });
                    }else{
                        this.permissions.push(permission)
                    }
                })
            }

        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>

    h6{
        color: #29b3a6;
        font-weight: 500;
    }
    .actions-inputs{
        display: inline-block;
        margin-right: 15px;
    }
    hr{
        margin-top: 0;
    }
</style>
